import { configureStore } from "@reduxjs/toolkit";

import thunkMiddleware from "redux-thunk";
import { scenario, auth, answer } from "./reducers";

const store = configureStore({
  reducer: { scenario, auth, answer },
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware().concat(thunkMiddleware);
  },
  devTools: process.env.NODE_ENV === "production" ? false : true,
});

export default store;
